<template>
  <div
    v-for="L1Section in computedSections"
    :key="L1Section"
    :class="{ 'three-quarter-width': applyFilters }"
    :data-scrollspy-id="L1Section.L1Heading.value.toLowerCase()"
  >
    <h2 class="tabular-data-heading">
      {{ L1Section.L1Heading.value }}
    </h2>

    <!-- LEVEL 2 SECTION (DATA NESTED INSIDE ACCORDION) -->
    <section v-for="L2Section in filteredItems(L1Section.L2Sections)" :key="L2Section" :cars-to-compare="carsToCompare">
      <div class="comparison-accordion__container">
        <CarComparisonAccordion :title="L2Section.L2Heading.value">
          <CarComparisonTable
            :is-mobile="isMobile"
            :filtered-items="filteredItems(L2Section.selectedDataPoints.targetItems)"
            :cars-to-compare="carsToCompare"
          />
        </CarComparisonAccordion>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CarComparisonAccordion from '../car-comparison/CarComparisonAccordion.vue';
import CarComparisonTable from '../car-comparison/CarComparisonTable.vue';

const props = defineProps({
  tabularData: {
    type: Object,
    required: true,
  },
  carsToCompare: {
    type: Array,
    required: true,
  },
  applyFilters: {
    type: Boolean,
    default: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  sectionToShow: {
    type: String,
    default: '',
  },
});

/**
 * Filter accordion based on combustion type.
 *
 * This filter will remove electric vehicle related
 * accordions for non-electric vehicles.
 */
const filteredItems = computed(() => {
  return (accordionsArray: any[]) => {
    return accordionsArray.filter((item) => {
      const matchedItems = item.hideFor.targetItems.find((e: any) => e.vehicleType.value === (props.carsToCompare as any[])[0]?.RACQ_SC_Vehicle_Type);

      if (props.applyFilters && item.hideFor.targetItems?.length > 0 && matchedItems?.vehicleType.value) {
        return false;
      }

      return true;
    });
  };
});

const computedSections = computed(() => {
  if (props.sectionToShow) {
    return props.tabularData.L1Sections.filter((section: any) => section.L1Heading.value.toLowerCase() === props.sectionToShow.toLowerCase());
  }

  return props.tabularData.L1Sections;
});
</script>

<style lang="scss" scoped>
.tabular-data-heading {
  margin-top: 3.75rem;
}
</style>
